export default __webpack_public_path__ + "static/media/sticker-it.240273d6.png";